/**
 * @generated SignedSource<<9cc173edd86d5753afe810260bf48288>>
 * @relayHash 4527ae63a2cf917389b3f2d0667f7b24
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 213cf4460d384977dd9e050ec432ad80bf1f3f2802c23ff15094e75716d2c1c6

import type { ConcreteRequest } from 'relay-runtime';
export type GoogleCalendarCardTenantContextQuery$variables = {
  cloudIds: ReadonlyArray<string>;
};
export type GoogleCalendarCardTenantContextQuery$data = {
  readonly tenantContexts: ReadonlyArray<{
    readonly orgId: string | null;
  } | null> | null;
};
export type GoogleCalendarCardTenantContextQuery = {
  response: GoogleCalendarCardTenantContextQuery$data;
  variables: GoogleCalendarCardTenantContextQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudIds"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudIds",
        "variableName": "cloudIds"
      }
    ],
    "concreteType": "TenantContext",
    "kind": "LinkedField",
    "name": "tenantContexts",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "orgId"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "GoogleCalendarCardTenantContextQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GoogleCalendarCardTenantContextQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "213cf4460d384977dd9e050ec432ad80bf1f3f2802c23ff15094e75716d2c1c6",
    "metadata": {},
    "name": "GoogleCalendarCardTenantContextQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "8d1a33c3833b62914f392aaf53e4a2f3";

export default node;
